<template>
  <section v-if="visibleCategories && visibleCategories.length > 0 
    " class="offers container my30">
    <div class="row">
      <div
        class="offer-container col-xs-12 col-sm-12 pb15"
        v-for="(link, index) in visibleCategories"
        :key="index"
      >
        <router-link :to="
          localizedRoute({
            name: 'category',
            params: { id: link.id, slug: link.url_path }
          })
        ">
          <div
            class="offer"
            v-lazy:background-image="link.image"
          >
            <h3 class="title m0 h1">
              {{ link.name }}
            </h3>
          </div>
        </router-link>
      </div>
    </div>
  </section>
  <section v-else-if="config.rootcategories.drukowanie === $route.meta.category && visibleCategories" class="offers container my30 px15">
    <div class="row">
      <div
        class="offer-container col-xs-12 col-sm-12 pb15"
        v-for="(banner, index) in banners.mainBanners"
        :key="index"
      >
        <router-link :to="localizedRoute(banner.link)">
          <div
            class="offer"
            v-lazy:background-image="banner.image"
          >
            <h3 class="title m0 h1">
              {{ banner.title }}
            </h3>
          </div>
        </router-link>
      </div>

      <div class="col-xs-12 col-sm-12">
        <div
          class="offer-container pb15"
          v-for="(banner, index) in banners.smallBanners"
          :key="index"
        >
          <router-link :to="localizedRoute(banner.link)">
            <div
              class="offer"
              v-lazy:background-image="banner.image"
            >
              <h3 class="title m0 h1">
                {{ banner.title }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import config from 'config';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'PromotedOffers',
  data () {
    return {
      config,
      allCategories: []
    }
  },
  props: {
    singleBanner: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      banners: 'promoted/getPromotedOffers',
    }),
    ...mapGetters('category', ['getCategories']),
    categories () {
      const result = this.allCategories.filter(op => {
        return op.level === 0 || op.level === 1;        
      });
      return result;
    },
    visibleCategories () {
      let catalog = this.$route.meta.category
      if (this.isOffice()) {
        catalog = config.rootcategories.biuro
      } else {
        catalog = config.rootcategories.drukowanie
      }
      const result = this.allCategories.filter(op => {
        return op.level === 2 && op.path.startsWith(catalog);
      });
      return result.filter(category => {
        return category.is_active
      });
    },
  },
  
  async created () {
    this.allCategories = this.getCategories;
    await this.updatePromotedOffers()
  },
  methods: {
    ...mapActions({
      updatePromotedOffers: 'promoted/updatePromotedOffers'
    }),
    async getAllCategories () {
      return await this.$store.dispatch('category/list', {
        sort: 'priority:desc',
        skipCache: true,
        includeFields: this.$store.state.config.entities.optimize
          ? this.$store.state.config.entities.category.includeFields
          : null
      })
    },
    isOffice () {
      const baseUrl = this.$router.options.base
      return baseUrl.startsWith(config.site.office_path)
    }
  }
}
</script>

<style lang="scss" scoped>
  .offers {
    min-height: 111px;
  }

  .offers.container {
    padding: 0;
    margin: 30px 0;

    @media (max-width: 768px) {
      margin: 0 0 30px;
    }
  }
  .offer-container {
    &:last-child {
      padding-bottom: 0;
    }
  }
  .offer {
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    opacity: 1;
    transition: 0.3s all;
    border-radius: 2.5rem;
    overflow: hidden;

    &:hover {
      opacity: 0.9;
    }

    @media (max-width: 767px) {
      height: auto;
    }

    .title {
      text-align: left;
      line-height: 3rem;
      color: #fff;
      font-size: 1.125rem;
      text-align: left;
      padding-left: 3em;
      font-family: "Roboto";
      margin-top: 0;
      background: #009de28a;
      width: 100%;
    }

    .subtitle {
      font-family: 'Roboto', sans-serif;
      @media (max-width: 767px) {
        background-color: rgba(255,255,255,0.4);
        padding: 0.5rem;
      }
    }
  }
  .offer-small {
    height: auto;

    @media (max-width: 767px) {
      height: auto;
    }
  }
  .offer-product {
    height: auto;
    background-position: 50% 20%;

    @media (max-width: 767px) {
      height: auto;
    }
  }
  .title {
    @media (max-width: 767px) {
      font-size: 36px;
    }
  }
  .subtitle {
    @media (max-width: 767px) {
      font-size: 18px;
    }
  }
</style>
